




















































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwTable, TableColumnConfig, TableEntry } from '@libs-uuif/shared/sw-table';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import { SwExpandableTextfield, SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { CreateElement, VNode } from 'vue';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { BreadcrumbItem, SwBreadcrumb } from '@sonicwall/unified-ui-framework/src/shared/sw-breadcrumb';
import { ContentToolbarExpandFilterBlock, SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
// import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwSlider } from '@sonicwall/unified-ui-framework/src/shared/sw-slider';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { ProductDropdown, UpgradePopup, ReleaseNotes, InfoPopup } from './components/index';
import DownloadList from './components/download-list.vue';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { InfoState, SetHelpContentIdPayload } from '../../core';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import PdfviewModal from './components/pdfview-modal.vue';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { Mutation } from 'vuex-class';
import ReleasetypeModal from './components/releasetype-modal.vue';
import ReleaseHelpDialog from '../free-downloads/components/release-help-dialog.component.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';

// import axios from 'axios';

const cssPrefix = 'download-center';
@Component({
  components: {
    SwTable,
    SwTitlePane,
    SwTextarea,
    SwButton,
    SwIcon,
    SwBreadcrumb,
    SwContentToolbar,
    SwIconButton,
    SwExpandableTextfield,
    SwToggle,
    SwSlider,
    SwContentToolbarExpand,
    ProductDropdown,
    UpgradePopup,
    ReleaseNotes,
    DownloadList,
    SwCheckbox,
    SwSelect,
    PdfviewModal,
    InfoPopup,
    MswAppTitle,
    ReleasetypeModal,
    ReleaseHelpDialog,
  },
  directives: {
    tooltip,
  },
})
export default class DownloadCenter extends SwExtendedVue {
  cssPrefix = cssPrefix;
  activeUser : boolean = true;
  get versionColumnConfig (): TableColumnConfig[] {
    return [{
      key: 'Version',
      dataKey: '',
      title: this.$t('downloadcenter.ver')
      .toString(),
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => this.loadVersion(h, data),
    }];
  }

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  showReleaseHelp: boolean = false;
  showReleaseNotes: boolean = false;
  searchInputText: string = '';
  apiResponse : any;
  versionData : TableEntry[]  = [];
  currentFolderObject : any;
  currentFolderName : string = '';
  showBreadCrumbs : boolean = false;
  levelOfNavigation = 1;
  breadcrumbs: BreadcrumbItem[] = [];
  clickRowToExpand : boolean = false;
  showFileMode : boolean = false;
  expandVisible: boolean = false;
  versionDataForFiles : TableEntry[] = [];
  // Search Filter
  isExpandSearchFilter: boolean = false;
  showLatestToggle : boolean = false;
  languageOpt : any = [];
  language : string = '';
  releaseTypeOpt : any = [];
  releaseType : string = '';
  expiringOnSelectValue: string = 'All';
  productSelected : boolean = false;
  currentSelectedProduct : string = '';
  tncText : string = '';
  termsAndConditionFlag : boolean = false;
  showInfoPopup: boolean = false;
  dropdownItems: any = [
    {
      heading: this.$t('downloadcenter.myProducts')
      .toString()
      .toUpperCase(),
      products: [],
    },
    {
      heading: this.$t('downloadcenter.otherProd')
      .toString()
      .toUpperCase(),
      products: [],
    },
  ];
  languageItemsOpt: SelectOption[] = [];
  languageItemsOptVal : string = '';
  filterLanguageSelected : string = '';
  filterLanguageCodeSelected : string = '';
  filterReleaseSelected : string = '';
  filterApplied : boolean = false;
  expiringOnCategories: string[] = ['All', 'Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Last 90 days', 'Last 180 days'];
  filteredVersionData : TableEntry[] = [];
  filteredClientFolderData : TableEntry[] = [];
  showPdfViewDialog : boolean = false;
  pdfUrl : string = '';
  showClientFolderFile : boolean = false;
  clientFolderData : TableEntry[] = [];
  fileFolderAtSameLevel : boolean = false;
  tableConfigForFileList: TableColumnConfig[] =
    [{
      key: 'expand',
      type: 'expand',
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
          </div>
        ) as VNode;
      },
    },
    {
      key: 'productType',
      dataKey: '',
      title: this.$t('products.producttype')
      .toString(),
      width : 300,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          !data.entry.hasClientFolder ?
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 5px;">{data.entry.productType}</span>
            <div  style="display: flex; flex-direction: column; align-items:center; justify-content: center;">
            <div onClick={() => { this.onInfoIconClick(data); }} style="cursor:pointer;">
              <div onMouseover={() => { this.onInfoIconClick(data); }} ><SwIcon name="informational" color="#47afe2" props-size={18}></SwIcon></div>
              { data.entry.showInfoPopup ?
              <InfoPopup popUpData={data.entry.popUpData}
              dropdownOpen={data.entry.showInfoPopup} onClosePopup={() => { this.closePopup(data.entry.versionDataForFilesIndex, data.index); }}/> :
               <div></div>}
            </div>
            </div>
          </div> :
          <div style="display: flex;align-items: flex-start;" onClick={() => { this.traverseForward(data); }}>
         <SwIcon name="folder-minus" size={20}></SwIcon>
         <span style="margin-left:10px;color:#47afe8;font-size: 14px;cursor:pointer;font-weight:500;">{ this.$t('downloadcenter.clntFldr')
         .toString() }</span>
          </div>
        ) as VNode;
      },
    }, {
      key: 'dummy',
      dataKey: '',
      title: this.$t('downloadcenter.dummy')
      .toString(),
      width: 300,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
          </div>
        ) as VNode;
      },
    }, {
      key: 'language',
      dataKey: '',
      title: this.$t('downloadcenter.language')
      .toString(),
      width:100,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          !data.entry.hasClientFolder ?
          <div>
            {data.entry.language}
          </div> : <div></div>
        ) as VNode;
      },
    }, {
      key: 'releaseType',
      dataKey: '',
      title: this.$t('products.type')
      .toString(),
      width: 150,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          !data.entry.hasClientFolder ?
          <div>
            {data.entry.releaseType}
          </div> : <div></div>
        ) as VNode;
      },
    }, {
      key: 'files',
      dataKey: '',
      width : 400,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }) : VNode => {
        return (
          !data.entry.hasClientFolder ?
          data.entry.softwareList.length > 0 ? <div>
          <DownloadList softwareList={data.entry.softwareList} isApplicable={data.entry.isApplicable} isActiveFirmware={data.entry.isActiveFirmware} onDownloadClick={(data : any) => {
            console.warn(data);
          }}/></div>
          : <div></div> : <div></div>
        ) as VNode;
      },
    }];
  tableConfigForFiles: TableColumnConfig[] =
    [{
      key: 'expand',
      type: 'expand',
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          data.entry.name ?
          <div class="download-center__file-list">
            <SwTable
                columns-config={this.tableConfigForFileList}
                footer-config={null}
                click-row-to-select={false}
                size="auto"
                table-data={data.entry.productTypes}></SwTable>
          </div> : <div></div>
        ) as VNode;
      },
    }, {
      key: 'name',
      dataKey: '',
      title: this.$t('products.name')
      .toString(),
      width: 300,
      scalable : true,
      // tslint:disable-next-line:no-unused
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        return (
          data.entry.hasChild === 'NO' ? data.entry.name ? <div>{data.entry.name}</div> :
           this.loadVersion(h, data) :
          <div onClick={() => { this.traverseForward(data); }}>
         <SwIcon {...{
           props: {
             name : 'folder-minus',
             size : 'small',
           }}}></SwIcon>
         <span style="margin-left:5px;color:#47afe8;font-size: 14px;cursor:pointer;">{data.entry.version}</span>
      </div>
        ) as VNode;
      },
    },
    {
      key: 'releaseDate',
      dataKey: 'releaseDate',
      title: this.$t('products.releasedate')
      .toString(),
      width: 150,
      scalable : true,
    },
    {
      key: 'firmwareEndDate',
      dataKey: 'firmwareEndDate',
      /* tslint:disable-next-line */
      title: (h: CreateElement): VNode => {
        return (
          <div style="display:flex;align-items:center;">
            <span style="margin-right:1rem;">{ this.$t('downloadcenter.eosDate')
            .toString() }</span>
            <div style="cursor:pointer;">
              <SwIcon name="informational" props-size={15} color="#47afe2" v-tooltip={{ content: this.$t('common.eosInfo'), compact: true, placement: 'bottom' }} ></SwIcon>
            </div>
          </div>
        ) as VNode;
      },
      width: 150,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <span style={ data.entry.firmwareStatus === 'ACTIVE' ? '' : 'color: red' }> {data.entry.firmwareEndDate} </span>
        ) as VNode;
      },
    },
    {
      key: 'language',
      dataKey: '',
      title: this.$t('downloadcenter.language')
      .toString(),
      width:100,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
          </div>
        ) as VNode;
      },
    }, {
      key: 'type',
      dataKey: '',
      width: 150,
      scalable : true,
      /* tslint:disable-next-line */
      title: (h: CreateElement): VNode => {
        return (
          <div style="display:flex;align-items:center;">
            <span style="margin-right:5px;">{this.$t('products.type')
            .toString()}</span>
            <div style="cursor:pointer;" onClick={() => { this.showReleaseNotePopup(); }}>
              <SwIcon name="informational" color="#47afe2" props-size={15}></SwIcon>
            </div>
          </div>
        ) as VNode;
      },
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          data.entry.name && data.entry.type ?
          <div>{data.entry.type}</div> : <div></div>
        ) as VNode;
      },
    }, {
      key: 'files',
      dataKey: '',
      width: 400,
      scalable : true,
      title: this.$t('downloadcenter.files')
      .toString(),
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          data.entry.hasChild === 'NO' && data.entry.showReleaseNoteIcon && data.entry.name ?
          <div style="color:#6b6b5b;display: flex;justify-content: center;align-items: center;">
            <div style="margin-right: 10px;display: flex;align-items: center;" onClick={() => { this.viewReleaseNotes(data); }}>
            <SwIcon name="view" size="small" props-size={18}
            v-tooltip={{
              content: 'View release notes',
              compact  : true,
              placement: 'bottom',
              maxWidth:275,
            } as TooltipDirValues}></SwIcon>
            </div>
            <div onClick={() => { this.openReleaseNotes(data); }} style="display: flex;justify-content:center;
            align-items: center;cursor:pointer;">
                <SwIcon name="download" size="small" props-size={18}></SwIcon>
                <span style="margin-left: 10px;">{ this.$t('downloadcenter.relseNotes')
                .toString()}</span>
            </div>
          </div> : <div></div>
        ) as VNode;
      },
    }];
  clientTableConfigForFiles: TableColumnConfig[] =
    [{
      key: 'expand',
      type: 'expand',
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
          </div>
        ) as VNode;
      },
    },
    {
      key: 'name',
      dataKey: '',
      title: this.$t('products.name')
      .toString(),
      width: 300,
      scalable : true,
      // tslint:disable-next-line:no-unused
      render: (h: CreateElement, data: { entry: TableEntry, index : any }): VNode => {
        return (
        <div style="display: flex; align-items: center;">
            <span style="margin-right: 5px;">{data.entry.name}</span>
            <div  style="display: flex; flex-direction: column; align-items:center; justify-content: center;">
            <div onClick={() => { this.onInfoIconClick(data); }} style="cursor:pointer;">
              <div onMouseover={() => { this.onInfoIconClick(data); }} ><SwIcon name="informational" color="#47afe2" props-size={18}></SwIcon></div>
              { data.entry.showInfoPopup ?
              <InfoPopup popUpData={data.entry.popUpData}
              dropdownOpen={data.entry.showInfoPopup} onClosePopup={() => { this.closePopup(-1, data.index); }}/> :
               <div></div>}
            </div>
            </div>
          </div>
        ) as VNode;
      },
    }, {
      key: 'releaseDate',
      dataKey: 'releaseDate',
      title: this.$t('products.releasedate')
      .toString(),
      width: 150,
      scalable : true,
    }, {
      key: 'language',
      dataKey: '',
      title: this.$t('downloadcenter.language')
      .toString(),
      width:100,
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          <div>
          {data.entry.language}
          </div>
        ) as VNode;
      },
    }, {
      key: 'type',
      dataKey: 'type',
      width: 150,
      scalable : true,
      /* tslint:disable-next-line */
      title: (h: CreateElement): VNode => {
        return (
          <div style="display:flex;align-items:center;">
            <span style="margin-right:5px;">{ this.$t('products.type')
            .toString()}</span>
            <div style="cursor:pointer;" onClick={() => { this.showReleaseNotePopup(); }}>
              <SwIcon name="informational" color="#47afe2" props-size={18}></SwIcon>
            </div>
          </div>
        ) as VNode;
      },
    }, {
      key: 'files',
      dataKey: '',
      width: 400,
      title: this.$t('downloadcenter.files')
      .toString(),
      scalable : true,
      /* tslint:disable-next-line */
      render: (h: CreateElement, data: { entry: TableEntry, index: number }): VNode => {
        return (
          data.entry.softwareList.length > 0 ? <div>
          <DownloadList softwareList={data.entry.softwareList} isApplicable={1} onDownloadClick={(data : any) => {
            console.warn(data);
          }}/></div>
          : <div></div>
        ) as VNode;
      },
    }];
  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        {
          title: this.$t('downloadcenter.language')
          .toString(),
          content: this.viewLanguageFilterRender,
          width: 230,
        },
        {
          title: this.$t('downloadcenter.releaseType')
          .toString(),
          content: this.viewReleaseFilterRender,
          width: 230,
        },
        {
          title: this.$t('products.releasedate')
          .toString(),
          content: this.viewDateFilterRender,
          width: 350,
        },
      ],
    ];
  }
  get getVersionDataForFiles(): TableEntry[] {
    let tableData : any;
    if (this.filterApplied) {
      if (this.fileFolderAtSameLevel) {
        tableData = this.versionData.concat(this.filteredVersionData);
      } else {
        tableData = this.filteredVersionData;
      }
    } else if (this.fileFolderAtSameLevel) {
      tableData = this.versionData.concat(this.versionDataForFiles);
    } else {
      tableData = this.versionDataForFiles;
    }
    return tableData.map((b : any) => {
      return Object.assign(
        {},
        b,
        { _toLoadChildren: false } as TableEntry,
        { _expandable:  b._expandable } as TableEntry,
      );
    });
  }
  get getClientFolderData(): TableEntry[] {
    if (this.filterApplied) {
      return this.filteredClientFolderData.map((b : any) => {
        return Object.assign(
        {},
        b,
        { _toLoadChildren:  false } as TableEntry,
        { _expandable:  b._expandable } as TableEntry,
      );
      });
    }
    return this.clientFolderData.map((b) => {
      return Object.assign(
        {},
        b,
        { _toLoadChildren: false } as TableEntry,
        { _expandable:  b._expandable } as TableEntry,
      );
    });
  }
  @Watch('expiringOnSelectValue')
  private updateDateFilterTiltle() {
    if (this.$refs.regDtFilterSlider) {
      const datetitle = this.expiringOnSelectValue;
      ((this.$refs.regDtFilterSlider as SwSlider).$refs.sliderBtn as HTMLElement).title = datetitle;
    }
  }

  openInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }

  releaseHelpDialog() {
    this.showReleaseHelp = false;
  }

  getApplicableVersions(data: any) {
    this.$store.commit('startLoading');
    this.$store.dispatch('DownloadCenterStoreModule/getApplicableVersion', data)
    .then((resp: any) => {
      if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
        this.apiResponse = resp;
        this.initializeResponse();
        this.$store.commit('stopLoading');
        this.productSelected = true;
    //   this.apiResponse = resp;
    //   this.initializeResponse();
        this.$store.commit('stopLoading');
      }
    });
  }

  created() {
    this.$store.commit('startLoading');
    // this.getApplicableVersions({ familyName: 'Firewall', isLatest: 'YES' });
    this.initializeDropDown();
    this.setHelpId('download-center');
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  initializeDropDown() {
    this.$store.dispatch('DownloadCenterStoreModule/getProductFamily', this.$store.getters.getUserId)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SUCCESS') {
          this.activeUser = true;
          resp.content.productFamilies.forEach((ele : any) => {
            if (ele.isMyProduct === 1) {
              this.dropdownItems[0].products.push({
                label: ele.familyDisplayName,
                familyName : ele.familyName,
                availableText: ele.availableText,
                isMyProduct: ele.isMyProduct,
              });
            } else {
              this.dropdownItems[1].products.push({
                label: ele.familyDisplayName,
                familyName : ele.familyName,
                availableText: ele.availableText,
                isMyProduct: ele.isMyProduct,
              });
            }
          });
          this.languageOpt = [{
            heading : 'Items',
            products: [],
          }];
          resp.content.languageList.forEach((ele: any) => {
            this.languageOpt[0].products.push({
              label: ele.Language,
              LanguageCode : ele.LanguageCode,
            });
          });
          this.releaseTypeOpt = [{
            heading : 'Items',
            products : [],
          }];
          resp.content.releaseTypeList.forEach((ele: any) => {
            this.releaseTypeOpt[0].products.push({
              label: ele.releaseType,
            });
          });
          this.$store.commit('stopLoading');
        } else if (resp.msgCode === 'MSWAPP:ACTIVATEDOWNLOAD') {
          this.$store.commit('startLoading');
          this.$store.dispatch('DownloadCenterStoreModule/getActivateSoftwareDownload', this.$store.getters.getUserId)
          .then((resp: any) => {
            this.activeUser =  false;
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              resp.content.languageList.forEach((ele: any) => {
                const inner : any = {};
                inner['id'] = ele.choidID.toString();
                inner['label'] = ele.Language;
                inner['value'] = ele.LanguageCode;
                this.languageItemsOpt.push(inner);
              });
              this.languageItemsOptVal = this.languageItemsOpt[0].id;
              this.tncText = resp.content.termsNConditions;
            }
          });
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      });
  }
  loadVersion(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    return (
      <div onClick={() => { this.traverseForward(data); }}>
         <SwIcon {...{
           props: {
             name : 'folder-minus',
             size : 'small',
           }}}></SwIcon>
         <span style="margin-left:5px;color:#47afe8;font-size: 14px;cursor:pointer;">{data.entry.version}</span>
      </div>
    ) as VNode;
  }
  async traverseForward(data: any) {
    if (this.levelOfNavigation === 1) {
      if (this.currentFolderObject[data.index].isChildPresent === 'YES') {
        this.currentFolderObject =  this.currentFolderObject[data.index].childVersions;
        this.versionData = [];
        this.currentFolderObject.forEach((ele : any, index: any) => {
          this.versionData.push({
            _expandable : false,
            _key : `${index.toString()}_folder`,
            version : ele.version,
            hasChild : ele.isChildPresent,
          });
        });
      }
      this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
        text: (h : CreateElement) => {
          return (
          <div onClick={() => {
            this.traverseBackward('All versions');
          }} style="color:#ff791a">{ this.$t('downloadcenter.allVersn')
            .toString()}</div>
        ) as VNode;
        },
        clickable : true,
        id : 'All versions',
      });
      this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
        text: (h : CreateElement) => {
          return (
          <div onClick={() => {
            this.traverseBackward(data.enry.version);
          }}>{data.entry.version}</div>
        ) as VNode;
        },
        clickable : false,
        id : data.entry.version,
      });
      this.showBreadCrumbs = true;
      this.levelOfNavigation += 1;
    } else {
      if (this.currentFolderObject[data.index].isChildPresent === 'YES') {
        this.loadBreadCrumbs(data);
        this.versionData = [];
        this.currentFolderObject[data.index].childVersions.forEach((ele : any, index: any) => {
          this.versionData.push({
            _expandable : false,
            _key : `${index.toString()}_folder`,
            version : ele.version,
            hasChild : ele.isChildPresent,
          });
        });
        if (this.currentFolderObject[data.index].softwarePresent === 'YES') {
          let dataSoftware : any;
          if (this.currentFolderObject[data.index].apiResponse) {
            dataSoftware = this.currentFolderObject[data.index].apiResponse;
          } else {
            dataSoftware = await (this.getSofwareVersionData(this.currentFolderObject[data.index].version)) ;
          }
          this.loadResponse(dataSoftware, data);
          this.currentFolderObject =  this.currentFolderObject[data.index].childVersions;
          this.showFileMode = true;
          this.fileFolderAtSameLevel = true;
        } else {
          this.currentFolderObject =  this.currentFolderObject[data.index].childVersions;
        }
        this.levelOfNavigation += 1;
      } else {
        this.fileFolderAtSameLevel = false;
        if (data.entry.hasClientFolder) {
          const tempObj = this.breadcrumbs[this.breadcrumbs.length - 1];
          this.breadcrumbs.pop();
          this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
            text: (h : CreateElement) => {
              return (
                <div onClick={() => {
                  this.traverseBackward(tempObj.id);
                }} style="color:#ff791a">{tempObj.id}</div>
        ) as VNode;
            },
            clickable : true,
            id : tempObj.id,
          });
          this.clientFolderData = [];
          data.entry.clientFolderData.forEach((element : any, index : any) => {
            this.clientFolderData.push({
              _expandable : false,
              _key : index.toString(),
              name: `${element.name} ${element.version}`,
              releaseDate : element.hasOwnProperty('releaseDate') ? element.releaseDate : '',
              language :  element.hasOwnProperty('languageCode') ? element.languageCode : '',
              releaseType : element.hasOwnProperty('releaseType') ? element.releaseType : '',
              type : element.hasOwnProperty('releaseType') ? element.releaseType : '',
              files : '',
              showReleaseNoteIcon : element.hasOwnProperty('releaseNotes') ? element.releaseNotes.trim().length > 0 ? true : false : false,
              releaseNotes: element.hasOwnProperty('releaseNotes') ? element.releaseNotes.trim().length > 0 ? element.releaseNotes : '' : '',
              filteredProductTypes : [],
              popUpData  : {
                downloadCount : element.hasOwnProperty('downloadCount') ? element.downloadCount.toString() : '',
                fileSize : element.hasOwnProperty('fileSize') ? element.fileSize.toString() : '',
                md5HashValue : element.hasOwnProperty('md5HashValue') ? element.md5HashValue.toString() : '',
                sha256HashValue : element.hasOwnProperty('sha256Hash') ? element.sha256Hash.toString() : '',
              },
              showInfoPopup : false,
              softwareList : [element],
              hasChild : 'NO'        });
          });
          this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
            text: (h : CreateElement) => {
              return (
          <div onClick={() => {
            this.traverseBackward('Client folder');
          }}>{ this.$t('downloadcenter.clntFldr')
            .toString()}}</div>
        ) as VNode;
            },
            clickable : false,
            id : 'Client folder',
          });
          this.showFileMode = false;
          if (this.filterApplied) {
            this.filterClientDataForFileArray();
          } else {
            this.showClientFolderFile = true;
          }
        } else if (!this.currentFolderObject[data.index].hasOwnProperty('apiResponse')) {
        // if (!this.currentFolderObject[data.index].hasOwnProperty('apiResponse')) {
          const data1 = { familyName:this.currentSelectedProduct, version:this.currentFolderObject[data.index].version };
          this.$store.dispatch('DownloadCenterStoreModule/getApplicableVersionSoftware', data1)
        .then((resp: any) => {
          if (resp.operationStatus === 'OK') {
            this.loadSoftwareVersion(resp, data);
            this.$store.commit('stopLoading');
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
            this.$store.commit('stopLoading');
          }
        });
        } else {
          this.loadSoftwareVersion(this.currentFolderObject[data.index].apiResponse, data);
        }
      }
    }
  }
  loadSoftwareVersion(resp : any, data: any) {
    this.loadBreadCrumbs(data);
    this.loadResponse(resp, data);
    if (this.filterApplied) {
      this.filterVersionDataForFileArray();
    } else {
      this.showFileMode = true;
    }
    this.checkForOneEntry(this.currentFolderObject[data.index].apiResponse);
  }
  checkForOneEntry(data : any) {
    if (data.content.versions.length === 1) {
      if (this.filterApplied && this.filteredVersionData.length === 1) {
        (this.$refs.tableExpand as SwTable).claimEntryExpanded(this.getVersionDataForFiles[0], true);
      } else if (!this.filterApplied) {
        (this.$refs.tableExpand as SwTable).claimEntryExpanded(this.getVersionDataForFiles[0], true);
      }
    }
  }
  async getSofwareVersionData(ver : any) {
    let response : any ;
    const data1 = { familyName:this.currentSelectedProduct, version: ver };
    await this.$store.dispatch('DownloadCenterStoreModule/getApplicableVersionSoftware', data1)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {

        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
        this.$store.commit('stopLoading');
        response =  resp;
      });
    return response;
  }
  filterClientDataForFileArray() {
    const filteredArray = this.clientFolderData.filter((ele : any) => {
      let flag = true;
      if (this.filterReleaseSelected !== '' && flag) {
        if (ele.releaseType.toLowerCase()
          .trim() !== this.filterReleaseSelected.toLowerCase()
          .trim()) {
          flag = false;
          // return false;
        }
      }
      if (this.filterLanguageSelected !== '' && flag) {
        if (ele.language.toLowerCase()
          .trim() !== this.filterLanguageCodeSelected.toLowerCase()
          .trim()) {
          flag = false;
          // return false;
        }
      }
      if (this.expiringOnSelectValue !== 'All' && this.expiringOnSelectValue !== ''  && flag) {
        if (!this.filterByDate(ele.releaseDate)) {
          flag = false;
          // return false;
        }
      }
      if (this.searchInputText !== ''  && flag) {
        // const indexList = ele.productTypes.findIndex((list : any) => list.productType.toLowerCase()
        // .includes(this.searchInputText.toLowerCase()
        //   .trim()));
        if (!ele.name.toLowerCase()
          .includes(this.searchInputText.toLowerCase()
          .trim())) {
          flag = false;
          // return true;
        }
      }
      return flag;
    });
    this.filteredClientFolderData = filteredArray;
    this.showClientFolderFile =  true;
  }
  filterVersionDataForFileArray() {
    const filteredArray = this.versionDataForFiles?.map((ele : any) => {
      const filteredProductTypes = ele?.productTypes?.length > 0 && ele?.productTypes?.filter((product : any) => {
        let flag = true;
        if (this.filterReleaseSelected !== '' && flag) {
          if (product?.releaseType?.toLowerCase()
            .trim() !== this.filterReleaseSelected.toLowerCase()
            .trim()) {
            flag = false;
          }
        }
        if (this.filterLanguageSelected !== '' && flag) {
          if (product?.language?.toLowerCase()
            .trim() !== this.filterLanguageCodeSelected.toLowerCase()
            .trim()) {
            flag = false;
          }
        }
        if (this.expiringOnSelectValue !== 'All' && this.expiringOnSelectValue !== ''  && flag) {
          if (!this.filterByDate(ele?.releaseDate)) {
            flag = false;
          }
        }
        if (this.searchInputText && flag) {
          const fieldsToSearch = [product?.productType?.toLowerCase(), product?.language?.toLowerCase(), product?.releaseType?.toLowerCase()];
          if (fieldsToSearch?.indexOf(this.searchInputText?.toLowerCase()
          .trim()) === -1) {
            flag = false;
          }
        }
        return flag;
      });
      return { ...ele, productTypes: filteredProductTypes };
    });
    this.filteredVersionData = filteredArray?.filter((element: any) => element?.productTypes?.length > 0);
    this.showFileMode = true;
  }
  filterByDate(releaseDate : any) {
    const releaseDateDay = Number(releaseDate.split(' ')[1]
    .replace(/,/g, ''));
    const releaseDateMonth = this.getMonthValue(releaseDate.split(' ')[0]);
    const releaseDateYear = Number(releaseDate.split(' ')[2]);
    let flag =  false;
    const todayDate = new Date();
    switch (this.expiringOnSelectValue) {
      case 'Today':
        if (todayDate.getDate() === releaseDateDay && todayDate.getMonth() + 1 === releaseDateMonth && todayDate.getFullYear() === releaseDateYear) {
          flag = true;
        }
        break;
      case 'Yesterday':
        todayDate.setDate(todayDate.getDate() - 1);
        const comparingDate = new Date(releaseDateYear , releaseDateMonth, releaseDateDay);
        if (comparingDate === todayDate) {
          flag = true;
        }
        break;
      case 'Last 7 days':
        todayDate.setDate(todayDate.getDate() - 7);
        const comparingDate1 = new Date(releaseDateYear , releaseDateMonth, releaseDateDay);
        if (comparingDate1 > todayDate) {
          flag = true;
        }
        break;
      case 'Last 30 days':
        todayDate.setDate(todayDate.getDate() - 30);
        const comparingDate2 = new Date(releaseDateYear , releaseDateMonth, releaseDateDay);
        if (comparingDate2 > todayDate) {
          flag = true;
        }
        break;
      case 'Last 90 days':
        todayDate.setDate(todayDate.getDate() - 90);
        const comparingDate3 = new Date(releaseDateYear , releaseDateMonth, releaseDateDay);
        if (comparingDate3 > todayDate) {
          flag = true;
        }
        break;
      case 'Last 180 days':
        todayDate.setDate(todayDate.getDate() - 180);
        const comparingDate4 = new Date(releaseDateYear , releaseDateMonth, releaseDateDay);
        if (comparingDate4 > todayDate) {
          flag = true;
        }
        break;
    }
    return flag;
  }
  getMonthValue(month : any) {
    let monthVal = 0;
    switch (month) {
      case 'Jan':
        monthVal = 0;
        break;
      case 'Feb':
        monthVal = 1;
        break;
      case 'Mar':
        monthVal = 2;
        break;
      case 'Apr':
        monthVal = 3;
        break;
      case 'May':
        monthVal = 4;
        break;
      case 'Jun':
        monthVal = 5;
        break;
      case 'Jul':
        monthVal = 6;
        break;
      case 'Aug':
        monthVal = 7;
        break;
      case 'Sep':
        monthVal = 8;
        break;
      case 'Oct':
        monthVal = 9;
        break;
      case 'Nov':
        monthVal = 10;
        break;
      case 'Nov':
        monthVal = 11;
        break;
    }
    return monthVal;
  }
  traverseBackward(name : any) {
    let fileModeEntered = false;
    const index = this.breadcrumbs.findIndex((ele : any) => ele.id === name);
    this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
    this.currentFolderObject = this.apiResponse.content.versions;
    if (name !== 'All versions') {
      const tempObj = this.breadcrumbs[this.breadcrumbs.length - 1];
      this.breadcrumbs.pop();
      this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
        text: (h : CreateElement) => {
          return (
          <div onClick={() => {
            this.traverseBackward(tempObj.id);
          }} >{tempObj.id}</div>
        ) as VNode;
        },
        clickable : false,
        id : tempObj.id,
      });
      this.levelOfNavigation = 1;
      this.breadcrumbs.forEach((item : any, ind : any) => {
        if (ind !== 0) {
          const objIndex = this.currentFolderObject.findIndex((ele : any) => ele.version === item.id);
          if (this.currentFolderObject[objIndex].hasOwnProperty('childVersions')) {
            if (this.currentFolderObject[objIndex].hasOwnProperty('apiResponse') && ind === (this.breadcrumbs.length - 1)) {
              this.versionData = [];
              this.currentFolderObject.forEach((ele : any, index : any) => {
                this.versionData.push({
                  _expandable : false,
                  _key : `${index.toString()}_folder`,
                  version : ele.version,
                  hasChild : ele.isChildPresent,
                });
              });
              const data = {
                index : objIndex,
              };
              this.loadResponse(this.currentFolderObject[objIndex].apiResponse, data);
              this.fileFolderAtSameLevel = true;
              this.showFileMode = true;
              fileModeEntered = true;
              this.currentFolderObject = this.currentFolderObject[objIndex].childVersions;
            } else {
              this.currentFolderObject = this.currentFolderObject[objIndex].childVersions;
            }
          } else if (this.showClientFolderFile && this.currentFolderObject[objIndex].hasOwnProperty('apiResponse')) {
            fileModeEntered = true;
            const data = {
              index : objIndex,
            };
            this.loadResponse(this.currentFolderObject[objIndex].apiResponse, data);
            if (this.filterApplied) {
              this.filterVersionDataForFileArray();
            } else {
              this.showFileMode = true;
            }
            this.checkForOneEntry(this.currentFolderObject[objIndex].apiResponse);
            this.showClientFolderFile = false;
            this.showFileMode = true;
          }
          this.levelOfNavigation += 1;
        } else {
          this.levelOfNavigation += 1;
        }
      });
      if (!fileModeEntered) {
        this.showClientFolderFile = false;
        this.versionData = [];
        this.currentFolderObject.forEach((ele : any, index : any) => {
          this.versionData.push({
            _expandable : false,
            _key : `${index.toString()}_folder`,
            version : ele.version,
            hasChild : ele.isChildPresent,
          });
        });
        this.showFileMode = false;
        this.versionDataForFiles = [];
      }
    } else {
      this.initializeResponse();
      if (this.versionData.filter((ele: any) => ele.hasChild === 'NO').length > 0) {
        this.loadFiles();
      } else {
        this.showFileMode = false;
        this.versionDataForFiles = [];
      }
    }
  }
  loadBreadCrumbs(data : any) {
    const version =  this.currentFolderObject[data.index].version;
    const tempObj = this.breadcrumbs[this.breadcrumbs.length - 1];
    this.breadcrumbs.pop();
    this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
      text: (h : CreateElement) => {
        return (
          <div onClick={() => {
            this.traverseBackward(tempObj.id);
          }} style="color:#ff791a">{tempObj.id}</div>
        ) as VNode;
      },
      clickable : true,
      id : tempObj.id,
    });
    this.breadcrumbs.push({
          // tslint:disable-next-line:no-unused
      text: (h : CreateElement) => {
        return (
          <div onClick={() => {
            this.traverseBackward(version);
          }}>{version}</div>
        ) as VNode;
      },
      clickable : false,
      id : version,
    });
  }
  loadResponse(resp : any, data : any) {
    const obj = this.currentFolderObject[data.index];
    obj['apiResponse'] = resp;
    this.currentFolderObject[data.index] = obj;
    this.versionDataForFiles = [];
    resp.content.versions.forEach((element : any, index : any) => {
      const productTypesCopy : any[] = [];
      if (element.hasOwnProperty('clientSoftwareList')) {
        if (element.clientSoftwareList.length) {
          productTypesCopy.push({
            _expandable : false,
            _key : -1,
            productType : '',
            language : '',
            firmWareUrl : '',
            downloadUrl : '',
            releaseType : '',
            softwareGroupID : '',
            softwareList : '',
            isApplicable : '',
            showInfoPopup : false,
            versionDataForFilesIndex : index,
            hasClientFolder : true,
            clientFolderData : element.clientSoftwareList,
            popUpData  : {
              downloadCount : '',
              fileSize : '',
              md5HashValue : '',
              sha256HashValue : '',
            },
          });
        }
      }
      element.softwareGroups.forEach((ele : any, index1 : any) => {
        productTypesCopy.push({
          _expandable : false,
          _key : index1.toString(),
          productType : ele.name,
          language : ele.languageCode,
          firmWareUrl : ele.releaseNoteURL,
          firmwareEndDate : ele.firmwareEndDate,
          firmwareStatus : ele.firmwareStatus,
          downloadUrl : ele.releaseNoteURL,
          releaseType : ele.releaseType,
          softwareGroupID : ele.softwareGroupID,
          softwareList : ele.softwareList,
          isApplicable : element.softwareGroups[index1].isApplicable,
          isActiveFirmware : ele.firmwareStatus === 'ACTIVE',
          showInfoPopup : false,
          versionDataForFilesIndex : index,
          hasClientFolder : false,
          clientFolderData : null,
          popUpData  : {
            downloadCount : ele.hasOwnProperty('downloadCount') ? ele.downloadCount.toString() : '',
            fileSize : ele.hasOwnProperty('fileSize') ? ele.fileSize.toString() : '',
            md5HashValue : ele.hasOwnProperty('md5HashValue') ? ele.md5HashValue.toString() : '',
            sha256HashValue : ele.hasOwnProperty('sha256Hash') ? ele.sha256Hash.toString() : '',
          },
        });
      });
      // not considering client folder for language  and release type
      // language and release type of all the child will be same to making the header language and release type same.
      const childIndex = productTypesCopy[0].hasClientFolder ? 1 : 0;
      this.versionDataForFiles.push({
        _expandable : true,
        _key : index.toString(),
        name: element.version,
        releaseDate : element.releaseDate,
        firmwareEndDate : productTypesCopy[childIndex].hasOwnProperty('firmwareEndDate') ? productTypesCopy[childIndex].firmwareEndDate : '',
        firmwareStatus : productTypesCopy[childIndex].hasOwnProperty('firmwareStatus') ? productTypesCopy[childIndex].firmwareStatus : '',
        language :  productTypesCopy[childIndex].hasOwnProperty('language') ? productTypesCopy[childIndex].language : '',
        releaseType : productTypesCopy[childIndex].hasOwnProperty('releaseType') ? productTypesCopy[childIndex].releaseType : '',
        type : '',
        files : '',
        showReleaseNoteIcon : element.hasOwnProperty('releaseNotes') ? element.releaseNotes.trim().length > 0 ? true : false : false,
        releaseNotes: element.hasOwnProperty('releaseNotes') ? element.releaseNotes.trim().length > 0 ? element.releaseNotes : '' : '',
        productTypes : productTypesCopy,
        filteredProductTypes : [],
        hasChild : 'NO'        });
    });
  }
  initializeResponse() {
    this.showFileMode = false;
    this.showClientFolderFile = false;
    this.versionDataForFiles = [];
    this.levelOfNavigation = 1;
    this.showBreadCrumbs = false;
    this.breadcrumbs = [];
    this.fileFolderAtSameLevel = false;
    this.currentFolderObject = this.apiResponse.content.versions;
    this.versionData = [];
    this.currentFolderObject.forEach((ele : any, index : any) => {
      this.versionData.push({
        _expandable : false,
        _key : `${index.toString()}_folder`,
        version : ele.version,
        hasChild : ele.isChildPresent,
      });
    });
  }
  loadFiles() {
    this.versionDataForFiles = [];
    this.currentFolderObject.forEach((ele : any, index: any) => {
      if (ele.isChildPresent === 'NO') {
        this.versionDataForFiles.push({
          _expandable : true,
          _key : index.toString(),
        //   name : ele.releaseName,
          name: ele.version,
          releaseDate : '12/6/2020',
          language :  '',
          type : '',
          files : '',
          productTypes : ele.productTypes,
          hasChild : 'NO'        });
      } else {
        this.versionDataForFiles.push({
          _expandable : false,
          _key : index.toString(),
          version : ele.version,
          releaseDate : '',
          language: '',
          type : '',
          files : '',
          hasChild : ele.isChildPresent,
        });
      }
    });
    this.showFileMode = true;
  }
  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  get isinIframe() {
    return (window.location.href !== window.parent.location.href &&
      this.$route.query.mode === 'APP') || false;
  }

  handleSearchFilter() {
    this.expandVisible ? this.expandVisible = false : '';
    this.isExpandSearchFilter = false;
    this.filterApplied = true;
    if (this.showFileMode) {
      this.filterVersionDataForFileArray();
    }
    if (this.showClientFolderFile) {
      this.filterClientDataForFileArray();
    }
  }
  handleShowLatestChange() {
    if (this.productSelected) {
      const template = { familyName: this.currentSelectedProduct, isLatest: this.showLatestToggle ? 'YES' : 'NO' };
      this.getApplicableVersions(template);
    }
  }
  private viewLanguageFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div class="languageDropDown">
        <ProductDropdown {...{
          props: {
            showSimpleDropdown: true,
            dropdownItems : this.languageOpt,
            placeholderText : (this.$t('downloadcenter.selectLanguage')
            .toString()),
            preSelected : this.filterLanguageSelected,
          },
          on: {
            selectedValue: (event :any) => {
              this.filterLanguageSelected = event;
            },
          },
        }}/>
      </div>
    ) as VNode;
  }
  private viewReleaseFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
     <div>
      <div>
     <ProductDropdown {...{
       props: {
         showSimpleDropdown: true,
         dropdownItems : this.releaseTypeOpt,
         placeholderText : (this.$t('downloadcenter.selectReleaseType')
         .toString()),
         preSelected : this.filterReleaseSelected,
       },
       on: {
         selectedValue: (event :any) => {
           this.filterReleaseSelected = event;
         },
       },
     }}/>
     </div>
     </div>
    ) as VNode;
  }
  private viewDateFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
        <div>
        <SwSlider
          {...{
            props: {
              categories : this.expiringOnCategories,
              value : this.expiringOnSelectValue,
              size: 'large',
              withDropdown: true,
            },
            attrs: {
              title: this.expiringOnSelectValue,
            },
            on: {
              change: (event : any) => {
                this.changeValue(event);
              },
            },
          }}></SwSlider>
      </div>) as VNode;
  }
  changeValue(event : any) {
    this.expiringOnSelectValue = event;
  }
  applyFilter() {
    this.expandVisible = !this.expandVisible;
    const languageArr = this.languageOpt[0].products.filter((ele : any) => ele.label === this.filterLanguageSelected);
    const releaseTypeArr = this.releaseTypeOpt[0].products.filter((ele : any) => ele.label === this.filterReleaseSelected);
    if (this.expiringOnSelectValue !== 'All' || languageArr.length > 0 || releaseTypeArr.length > 0) {
      languageArr.length > 0 ? this.filterLanguageCodeSelected = languageArr[0].LanguageCode : '';
      this.filterApplied = true;
    }
    if (this.showFileMode) {
      this.filterVersionDataForFileArray();
    }
    if (this.showClientFolderFile) {
      this.filterClientDataForFileArray();
    }
  }
  clearFilter() {
    this.expandVisible = false;
    this.filterReleaseSelected = '';
    this.filterLanguageSelected = '';
    this.expiringOnSelectValue = 'All';
    this.searchInputText = '';
    this.filterApplied = false;
  }
  dropdownSelected(data : any) {
    this.currentSelectedProduct =  data;
    const template = { familyName: data, isLatest: this.showLatestToggle ? 'YES' : 'NO' };
    this.productSelected = true;
    this.getApplicableVersions(template);
  }
  openReleaseNotes(data : any) {
    window.open(data.entry.releaseNotes, '_blank');
  }
  viewReleaseNotes(data : any) {
    this.pdfUrl = data.entry.releaseNotes;
    this.showPdfViewDialog = true;
  }
  redirectToDoc() {
    window.open('https://www.sonicwall.com/support/technical-documentation/?language=English', '_blank');
  }
  redirectToFirmware() {
    window.open('https://www.sonicwall.com/support/product-lifecycle-tables/#software-and-firmware-release-model', '_blank');
  }
  tncSubmit() {
    if (this.termsAndConditionFlag) {
      const req = {
        username : this.$store.getters.getUserId,
        choiceID : Number(this.languageItemsOptVal),
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('DownloadCenterStoreModule/postActivateSoftwareDownload', req)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          this.activeUser = true;
          this.initializeDropDown();
        }
      });
    } else {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'failed', infoMsg: 'Please accept the terms and conditions to proceed.' };
      this.$store.commit('enqueueMessage', message);
    }
  }
  onInfoIconClick(data : any) {
    if (this.showFileMode) {
      this.versionDataForFiles.forEach((file : any, index : any) => {
        const fileListIndex = file.productTypes.findIndex((fileList : any) => { return fileList.showInfoPopup; });
        if (fileListIndex > -1) {
          this.versionDataForFiles[index].productTypes[fileListIndex].showInfoPopup = false;
        }
      });
      this.versionDataForFiles[data.entry.versionDataForFilesIndex].productTypes[data.index].showInfoPopup = true;
    } else if (this.showClientFolderFile) {
      const fileListIndex = this.clientFolderData.findIndex((fileList : any) => { return fileList.showInfoPopup; });
      if (fileListIndex > -1) {
        this.clientFolderData[fileListIndex].showInfoPopup = false;
      }
      this.clientFolderData[data.index].showInfoPopup = true;
    }
  }
  closePopup(versionDataForFilesIndex : any, fileListIndex : any) {
    if (this.showFileMode) {
      this.versionDataForFiles[versionDataForFilesIndex].productTypes[fileListIndex].showInfoPopup = false;
      this.$set(this.versionDataForFiles, versionDataForFilesIndex, this.versionDataForFiles[versionDataForFilesIndex]);
    } else if (this.showClientFolderFile) {
      this.clientFolderData[fileListIndex].showInfoPopup = false;
      this.$set(this.clientFolderData, fileListIndex, this.clientFolderData[fileListIndex]);
    }
  }
  mutateFilterState(param : any) {
    switch (param) {
      case 'language' :
        this.filterLanguageSelected = '';
        if (this.expiringOnSelectValue === 'All' && this.filterReleaseSelected === '' && this.searchInputText === '') {
          this.clearFilter();
        } else {
          if (this.showClientFolderFile) {
            this.filterClientDataForFileArray();
          } else {
            this.filterVersionDataForFileArray();
          }
        }
        break;
      case 'releaseType' :
        this.filterReleaseSelected = '';
        if (this.expiringOnSelectValue === 'All' && this.filterLanguageSelected === '' && this.searchInputText === '') {
          this.clearFilter();
        } else {
          if (this.showClientFolderFile) {
            this.filterClientDataForFileArray();
          } else {
            this.filterVersionDataForFileArray();
          }
        }
        break;
      case 'releaseDate' :
        this.expiringOnSelectValue = 'All';
        if (this.filterReleaseSelected === '' && this.filterLanguageSelected === '' && this.searchInputText === '') {
          this.clearFilter();
        } else {
          if (this.showClientFolderFile) {
            this.filterClientDataForFileArray();
          } else {
            this.filterVersionDataForFileArray();
          }
        }
        break;
      case 'customSearch' :
        this.searchInputText = '';
        if (this.filterReleaseSelected === '' && this.filterLanguageSelected === '' && this.expiringOnSelectValue === 'All') {
          this.clearFilter();
        } else {
          if (this.showClientFolderFile) {
            this.filterClientDataForFileArray();
          } else {
            this.filterVersionDataForFileArray();
          }
        }
        break;
    }
  }
  closeDialog() {
    this.showPdfViewDialog = false;
    this.showReleaseNotes = false;
  }
  showReleaseNotePopup() {
    this.showReleaseNotes = true;
  }
}
